 /* eslint-disable */

import './datepicker.css';
import './MessageDisplayPagecss.css';
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
//import 'timepicker/jquery.timepicker.css';
import 'sweetalert2/src/sweetalert2.scss';

import React, {
    Component,
    Suspense,
    lazy
} from 'react';
import { Route, BrowserRouter as Router } from 'react-router-dom';

import $ from 'jquery';
import CryptoJS from 'crypto-js';
import { GSheetsAPIIntegrationTestFunc } from './GSheetsAPIIntegration';
import { LoadingPage } from './LoadingPage';
import OtpInput from 'react-otp-input';
import ReactDOM from 'react-dom';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import _ from 'underscore';
import logomb from './image/tictokn40.png';

const SignIn = lazy(() => import('./SignIn'));
const SignUp = lazy(() => import('./SignUp'));
export default class VerificationMailSentMessage extends Component {

    constructor(props) {
        super(props)
      
        this.state = {
            otp: '',
            
        }
    }
    render() {
        return (
            <div className="container-fluid">
				<div class="row">
					<div class="col-md-4 leftside_box">
					<div class="leftside_imgotpimage">
                            {/* <img src={imgss} /> */}
                        </div>						
					</div>
					<div class="col-md-8">
                    <div class="old_account" style={{position:'absolute',justifyContent:'center'}}>
                     <p class="logomb"><img src={logomb} />
                     <span class="logotext">Tictoks</span>
                     </p>                                          
                 </div> 	
					<div class="rightside_text">
				    
                 <div id="rightside">
                 <OtpPage emailId={this.props.emailId}/>  
                 </div>  
                    </div>
                    </div>
                    </div>
        
        </div>

        );
                        }
                    };

export class OtpPage extends Component
{
    constructor(props) {
        super(props)
         
        this.state = {
            
			otp: '',
            emailId:'',
            password:'',
            firstName:'',
            lastName:'',
			valid:false,
            holidayTableNextYear: "No",
            pinCode: '000000',
            thirdPartLogin: 'No',
            planName: "elite",
            permission: "avoidAttendanceTracking,supervisorAuthority,checkinout,manualAttendance,dailyAttendanceReport,"
                + "monthlyAttendanceReport,periodAttendanceReport,employeechartAttendanceReport,"
                + "employeeActivities,departmentActivities,roleActivities,permissionActivities,"
                + "supportCreateCase,addEmployeeExcel,updateEmployeeExcel,addLocationExcel,"
                + "employeeInformationReport,departmentwiseReport,singleswipeReport,statusUnknownReport,"
                + "lateCheckinReport,earlyCheckOutReport,auditReport,supportCaseHistory,locationActivities,"
                + "locateEmployee,addVehicle,trackVehicle,locateDevice,locateVehicle,"
                + "tripHistoryReport,deviceReport,attendanceRegularization,Leave,"
                + "leaveReport,leaveHistoryReport,sms,email,smsReport,emailReport,"
                + "shiftActivities,shiftMigration,shiftActivityCalendar,shiftOrganizationCalendar,"
                + "shiftAutomation,shiftReport,datewiseshiftReport,monthwiseShiftReport,"
                + "periodShiftReport,shiftVacancyReport,expiredShiftReport,shiftDeletedReport,supervisorsubordinateShiftReport,"
                + "scheduledShiftReport,shiftDeletedReport,workfromHomeConfiguration,workfromHomeDeleteFile,"
                + "workfromHomeReport,workfromHomeStatistics,workfromHomeBusinessAnalytics,"
                + "datewiseWorkfromHomeReport,monthlyWorkfromHomeReport,weeklyWorkfromHomeReport,"
                + "periodWorkfromHomeReport,workfromHomeAppInstalledReport,timesheetAttendance,"
                + "timesheetAdmin,timesheetReport,timesheetImport,timesheetExport,payment,"
                + "paymentHistoryReport,minimumWrkingHr,firstCheckInLastCheckOut,wifiSettings,"
                + "shiftConfigurations,holidayConfiguration,nonmandatoryfieldConfiguration,"
                + "companySettingsConfiguration,orderCreationAssignment,resourceReport,taskReport,assignedTaskReport",
            permissionHeader: "attendanceManagement,employeeMaintenance," +
                "trackingNavigation,requestApproval,communication,shiftManagement," +
                "workfromHome,timeSheet,paymentManagement,configuration,orderManagement",


        };
    }
    componentDidMount(){
        $(".OTPError").empty();
        let key = "shinchanbaby";
       if (localStorage.getItem("EmailId")){
            let emailId=CryptoJS.AES.decrypt(localStorage.getItem("EmailId"), key).toString(CryptoJS.enc.Utf8);
            let password=CryptoJS.AES.decrypt(localStorage.getItem("Password"), key).toString(CryptoJS.enc.Utf8);
            let firstName=CryptoJS.AES.decrypt(localStorage.getItem("FirstName"), key).toString(CryptoJS.enc.Utf8);
            let lastName=CryptoJS.AES.decrypt(localStorage.getItem("LastName"), key).toString(CryptoJS.enc.Utf8);
        this.setState({
            emailId,
            password,
            firstName,
            lastName
        })
    }
       
    }
    ResendCode(){
        var key = "shinchanbaby";
        let emailId=CryptoJS.AES.decrypt(localStorage.getItem("EmailId"), key).toString(CryptoJS.enc.Utf8);
        let password=CryptoJS.AES.decrypt(localStorage.getItem("Password"), key).toString(CryptoJS.enc.Utf8);
        let firstName=CryptoJS.AES.decrypt(localStorage.getItem("FirstName"), key).toString(CryptoJS.enc.Utf8);
        let lastName=CryptoJS.AES.decrypt(localStorage.getItem("LastName"), key).toString(CryptoJS.enc.Utf8);
       
        $.ajax({
            type: 'POST',
            data: JSON.stringify({
                firstName: firstName,
                lastName:lastName,
                emailId: emailId,
                password: password
            }),
           // url: "http://localhost:8080/EmployeeAttendenceAPI/SignUpActivities/SignUpWithOTP",
            url: serverUrl+"/EmployeeAttendenceAPI/SignUpActivities/SignUpWithOTP",

            contentType: "application/json",
            dataType: 'json',
            crossDomain: true,
            success: function (data, textStatus, jqXHR) {
                console.log("OTp ",data.otp)

                if (data.response == "Success") {

                    localStorage.setItem('OTP', CryptoJS.AES.encrypt(data.otp.toString(), key));
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        text: "Verification code has been resend to your "
                        + "authorized EmailId kindly verify your EmailId",
                        timer: 2000
                    })
                } else{
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        text: "Oops!! Try again later",
                        timer: 2000
                    })
                }
                


            },
            error: function (data, textStatus, jqXHR) {

                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'No Internet',
                    text: 'Network Connection Problem',
                    timer: 2000
                })

            },

        });


    }
    Verify = () => {
        var self = this;
        var today = new Date();
        var date = toDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        var fromDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        today.setDate(today.getDate() + 14);
        var toDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        var self = this;
        $.ajax({
            type: 'POST',
            data: JSON.stringify({
                emailId: this.state.emailId,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                siteName: '',
                password: this.state.password,
                mobileNo: '',
                address: '',
                city: '',
                country: '',
                pinCode: this.state.pinCode,
                state: '',
                companyType: '',
                planName: 'elite',
                permission: this.state.permission,
                permissionHeader: this.state.permissionHeader,
                trial: 'Yes',
                fromDate: fromDate,
                toDate: toDate,
                gstin: '',
                date: date,
                timeZone: '',
                area: '',
                holidayTableNextYear: '',
                zipCode: '',
            }),
            // url: "http://localhost:8080/EmployeeAttendenceAPI/SignUpActivities/SignUpVerification",
            url: serverUrl+"/EmployeeAttendenceAPI/SignUpActivities/SignUpVerification",

            contentType: "application/json",
            dataType: 'json',
            async: false,

            success: function (data, textStatus, jqXHR) {

                console.log("BASIC DATA :", data);


                if (data.response == "Success") {

                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        text: "Your Email Id has been Verified Successfully",
                        timer: 2000
                    })


                  //  GSheetsAPIIntegrationTestFunc(self.state.firstName, self.state.lastName, self.state.emailId);
                    ReactDOM.render(<OtpVerified />, document.getElementById("rightside"));

                    //  LoginFunc(self.state);       
                    //ReactDOM.render(<MailVerifiedMessage emailId={self.state.emailId} password={self.state.password} />, document.getElementById("root"));


                } else if (data.response == "EmailId_AlreadyExist") {
                    Swal.fire({
                        position: 'center',
                        icon: 'warning',
                        text: "You have already Regeistered with Tictoks",
                        timer: 2000
                    });
                    var uri = window.location.toString();
                    let clean_uri = uri.substring(0, uri.indexOf("?"));
                    window.history.replaceState({}, document.title, clean_uri);
                    ReactDOM.render(
                        <Router>
                            <Suspense fallback={<LoadingPage />}>
                                <div >
                                    <Route path="/" component={SignIn} />
                                </div>
                            </Suspense>
                        </Router>, document.getElementById('root'));
                }
            },
            error: function (data) {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Network Connection Problem',
                    showConfirmButton: false,
                    timer: 2000
                })


            }

        });


		
        // [<VerificationMailSentMessage />, <OtpVerified />],
	}
    SignUpBackbtnFunc() {
        ReactDOM.render(
            <Router>
                <Suspense fallback={<LoadingPage />}>
                    <div >
                        <Route  path="/" component={SignUp} />
                    </div>
                </Suspense>
            </Router>, document.getElementById('root'));
	}
    handleChange = (otp) =>
    {
        var a= otp;
        if (a.length >=6) {
            $(".OTPError").empty();
            let dbotp=CryptoJS.AES.decrypt(localStorage.getItem("OTP"), "shinchanbaby").toString(CryptoJS.enc.Utf8);
            console.log("dbotp ",dbotp,otp)
            if(Number(otp)===Number(dbotp)){
                this.setState({
                    valid: true,
                    otp:otp
                });
              //  this.Verify();
                
            }else{
                $(".OTPError").empty()
                $(".OTPError").append("Sorry! This isn't the Right Code !");
            }    
        }
        else{
            $(".OTPError").empty()
            $(".OTPError").append("Sorry! This isn't the Right Code !");
            this.setState({
				valid: false,
                otp:otp
			});
        }
    this.setState({
         otp });
    }
    
    render(){
    return(
        <div class="form-group">
        <div class="circles">
        <div class="top-icon">
            <div class="top-inicon">
            <i class="fa fa-envelope" aria-hidden="true"></i>
        </div>
        </div>
        </div>
        <div class="text-center">
        <h3>We Just Emailed You!</h3>						
        <p>Please enter the Verification Code below.</p>
        <a class="color">{this.props.emailId}.</a>
        <div class="otpbox">
        <OtpInput
        value={this.state.otp}
        onChange={this.handleChange}
        numInputs={6}
        isInputNum="true"
      />
      </div>
      <span class="mt-10 OTPError" style={{ color: 'red' }}></span>
            </div>
        <button type="button" disabled={!this.state.valid}  onClick={() => this.Verify()} class="btn btn-primary signIn_btn">Verify</button>	
        <p class="mt-top text-center">Didn't receive an email? <a class="color" onClick={()=>this.ResendCode()}>resend Code</a></p>
        <ul class="previous disabled goback mt-top" id="">
    <a href="#" onClick={() => this.SignUpBackbtnFunc()}><span class="backlogin"><i class="fa fa-long-arrow-left" aria-hidden="true"></i> Back to Login</span></a></ul>
    </div>
    )
}
};

export class OtpVerified extends Component
{

    BackbtnFunc = () => {
        ReactDOM.render(
            <Router>
                <Suspense fallback={<LoadingPage />}>
                    <div >
                        <Route path="/" component={SignIn} />
                    </div>
                </Suspense>
            </Router>, document.getElementById('root'));
	}

    render(){
    return(
            <div className="container-fluid">
				<div class="row">
					<div class="col-md-4 leftside_box">
					<div class="leftside_imgotpimage">
                            {/* <img src={imgss} /> */}
                        </div>						
					</div>
					<div class="col-md-8">
                    <div class="old_account" style={{position:'absolute',justifyContent:'center'}}>
                     <p class="logomb"><img src={logomb} />
                     <span class="logotext">Tictoks</span>
                     </p>                                          
                 </div> 	
					<div class="rightside_text">
				    
                 <div id="rightside">
            
        <div class="form-group">
        <div class="circles">
        <div class="top-icon">
            <div class="top-inicon">
            <i class="fa fa-check-circle" aria-hidden="true"></i>
        </div>
        </div>
        </div>
        <div class="text-center">
        <h3>Account Verified</h3>						
        <p>Your email address has been succesfully verified.</p>
        <span class="mt-10">Click below to log in magically.</span>
        </div>
        <button type="button" onClick={() => this.BackbtnFunc()} class="btn btn-primary signIn_btn">Continue to Login</button>	
    </div>
    </div>
    </div>
    </div>
    </div>
    </div>
    
    )
}
};

        // function Step1(props) {
        //     return (
        //         <div class="form-group">
        //         <div class="circles">
        //         <div class="top-icon">
        //             <div class="top-inicon">
        //             <i class="fa fa-envelope" aria-hidden="true"></i>
        //         </div>
        //         </div>
        //         </div>
        //         <div class="text-center">
        //         <h3>We Just Emailed You!</h3>						
        //         <p>Please enter the Verification Code below.</p>
        //         <a class="color">xxxddd@gmail.com.</a>
        //         <div class="otpbox">
        //         <OtpInput
        //         class="otp"
        //         value={props.otp}
        //         onChange={props.handleChange}
        //         numInputs={6}
        //       />
        //       </div>
        //       <span class="mt-10">Sorry! This isn't the Right Code</span>
        //             </div>
        //         <button type="button" onClick={() => this.BackbtnFunc()} class="btn btn-primary signIn_btn">Verify</button>	
        //         <p class="mt-top text-center">Didn't receive an email? <a class="color">resend Code</a></p>
        //         <ul class="previous disabled goback mt-top" id="">
        //     <a href="#" onClick={() => this.SignUpBackbtnFunc()}><span class="backlogin"><i class="fa fa-long-arrow-left" aria-hidden="true"></i> Back to Login</span></a></ul>
        //     </div>
        //     );
        //   }
        //   function Step2(props) {
        //     return (
        //         <div class="form-group">
        //         <div class="circles">
        //         <div class="top-icon">
        //             <div class="top-inicon">
        //             <i class="fa fa-check-circle" aria-hidden="true"></i>
        //         </div>
        //         </div>
        //         </div>
        //         <div class="text-center">
        //         <h3>Account Verified</h3>						
        //         <p>Your email address has been succesfully verified.</p>
        //         <span class="mt-10">Click below to log in magically.</span>
        //         </div>
        //         <button type="button" onClick={() => props.BackbtnFunc()} class="btn btn-primary signIn_btn">Continue to Login</button>	
        //     </div>		
        //     );
        //   }




